import axios from "axios";

import { LMS_BASE_URL } from "../../../../utils/http/http-common";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";

export const saveInclusiveContentApiCall = async (body) => {
  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(
      `${LMS_BASE_URL}/chapter/percentage-update`,
      {
        courseId: body.courseId,
        moduleId: body.moduleId,
        chapterId: body.chapterId,
        totalParts: body.totalParts,
        part: body.part,
      },
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};
